/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import CampaignModel from 'cio/models/campaign';
import AuthService from 'cio/services/auth';
import { ExitCondition, selectedExitCondition } from 'cio/utils/campaigns/exit-conditions';
import { tracked } from '@glimmer/tracking';
import AccountService from 'cio/services/account';

interface CampaignExitSetupArgs {
  campaign: CampaignModel;
}

export default class CampaignExitSetup extends Component<CampaignExitSetupArgs> {
  @service account!: AccountService;
  @service auth!: AuthService;
  @service features!: FeaturesService;

  @tracked isFeedbackModalOpen = false;

  readonly ExitCondition = ExitCondition;

  get selectedExitCondition() {
    return selectedExitCondition(this.args.campaign);
  }

  get showExitAfterFirstMessageOption() {
    return this.args.campaign.exitOnlyAfterMessage || this.features.isEnabled('exit_only_after_message');
  }

  @action
  selectExitCondition(exitCondition: ExitCondition) {
    if (exitCondition === ExitCondition.NoExit) {
      this.args.campaign.setProperties({
        exitOnTriggerOrFilterNotMatched: false,
        exitOnConversionMatched: false,
        exitOnlyAfterMessage: false,
      });
    } else if (exitCondition === ExitCondition.GoalMet) {
      this.args.campaign.setProperties({
        exitOnTriggerOrFilterNotMatched: false,
        exitOnConversionMatched: true,
      });
    } else if (exitCondition === ExitCondition.UnmatchTrigger) {
      this.args.campaign.setProperties({
        exitOnTriggerOrFilterNotMatched: true,
        exitOnConversionMatched: false,
      });
    } else if (exitCondition === ExitCondition.GoalMetOrUnmatchTrigger) {
      this.args.campaign.setProperties({
        exitOnTriggerOrFilterNotMatched: true,
        exitOnConversionMatched: true,
      });
    }
  }

  @action
  changeExitOnlyAfterMessage(checked: boolean) {
    this.args.campaign.set('exitOnlyAfterMessage', checked);
  }

  @action
  toggleFeedbackModal() {
    this.isFeedbackModalOpen = !this.isFeedbackModalOpen;
  }
}
